import { formatNumberOnLocale, getInkTranslation } from '../../../../../constants/AppMethod';
import currencies from '../../../../../constants/CurrencyTypes';
import { useTranslation } from "react-i18next";
import EcoProButton from "../../../../../components/shared/button/button";
import SvgInkDrop from '../../../../../components/SvgContainer/SvgIcons/SvgInkDrop';
import SvgInkDropAll from '../../../../../components/SvgContainer/SvgIcons/SvgInkDropAll';
import SvgEncircledPlus from "../../../../../components/SvgContainer/SvgIcons/SvgEncircledPlus";
import SvgEncircledMinus from '../../../../../components/SvgContainer/SvgIcons/SvgEncircledMinus';
import './EasyBuyOptionsMobileView.css'
import { useState,useContext } from 'react';
import { EasyBuyContext } from './EasyBuy';

const EasyBuyOptionsMobileView = () =>{
    const value = useContext(EasyBuyContext);
    const {inkDetails, easyBuySummaryData,getPrice,selectedCapacities, handleCapacityChange, setEasyBuySummaryData} = value;
    const { t } = useTranslation();
    
    const [showInkOptions, setShowInkOptions] = useState(() => {
        return Object.entries(inkDetails).reduce((acc, color) => {
            return { ...acc, [color[0]]: false };
        }, {});
    });

    const toggleInkOptions = (colorName) => {
        setShowInkOptions(prevState => ({
            ...prevState,
            [colorName]: !prevState[colorName]
        }));
    };

    return(
        <div className='easyBuy-Mobile-View'>
        { inkDetails.map((color, index) => {
            const variant = getPrice(color);
            return(
                <div className={`inkDetailsInfo ${!showInkOptions[color.name] ? 'removeBorderRadius' :''} ${index === inkDetails.length -1 ? 'bottomBorderRadius' : index === 0 ? 'topBorderRadius' : '' }`}>
                    <div className='inkHeaderInfo'>
                        <div>
                        { color.colours === 'all' ? <SvgInkDropAll></SvgInkDropAll> : <SvgInkDrop width={16} height={21} color={color.colours}></SvgInkDrop> }
                            <span> {getInkTranslation(color.name)} </span>
                        </div>
                        { !showInkOptions[color.name] && <span onClick={() => toggleInkOptions(color.name)} > <SvgEncircledPlus width={24} height={24}></SvgEncircledPlus> </span> }
                        { showInkOptions[color.name] && <span onClick={() => toggleInkOptions(color.name)} > <SvgEncircledMinus width={24} height={24}></SvgEncircledMinus> </span> }
                    </div>
                    { showInkOptions[color.name] && <div className='inkOptionsInfo'>
                        <div>
                            <label> {t("EASY_BUY.TABLE_HEADERS.CAPACITY")} </label>
                            <div className="detail-value">
                                <select
                                    value={selectedCapacities[color.name]}
                                    onChange={(e) =>
                                        handleCapacityChange(color.name, e.target.value)
                                    }
                                    >
                                    {color.capacityOptions.map((opt) => (
                                        <option key={opt} value={opt}>
                                        {opt}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div>
                            <label> {t("EASY_BUY.TABLE_HEADERS.PRICE")} </label>
                            <div className="strike-price">
                                {formatNumberOnLocale(variant?.priceWithoutTax, currencies[variant?.currency]?.code)}
                            </div>
                            <div>{formatNumberOnLocale(variant?.discountedPrice, currencies[variant?.currency]?.code)}</div>
                        </div>
                        <EcoProButton
                            cname="add-ink-button-container"
                            disabled={!!easyBuySummaryData?.find(item => item.name === color.name)}
                            onBtnClick={() => {
                            setEasyBuySummaryData(prevData => [
                                ...prevData,
                                {
                                ...color,
                                discountedPrice: variant.discountedPrice,
                                details: variant.pages,
                                price: variant.price,
                                currency: variant.currency,
                                label: variant.label,
                                supplyItemCode:variant.supplyItemCode
                                }
                            ]);
                            }}
                        >
                            {t("EASY_BUY.ADD_BUTTON")}
                        </EcoProButton>
                    </div> }
                </div>
            );
        } ) }
        </div>
    );
}

export default EasyBuyOptionsMobileView;